import { ajaxHandler, platformFormData, toast } from "./utilities/utilities";

window.addEventListener('DOMContentLoaded', function () {

    const googleLoginWrapper = document.getElementById('platform-google-login');
    const googleClientID = googleLoginWrapper ? googleLoginWrapper.dataset.cid : '';

    if (googleLoginWrapper) {
        // Init google auth.
        google.accounts.id.initialize({
            client_id: googleClientID,
            callback: handleCredentialResponse
        });

        // Render button
        google.accounts.id.renderButton(
            googleLoginWrapper,
            { theme: "outline", size: "large", width: "100%" }
        );

        /**
         * Decode JWT response
         *
         * @param {*} token encoded token
         * @returns  object
         */
        function decodeJwtResponse(token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        };


        /**
         * Handle response after user consent
         */
        async function handleCredentialResponse(response) {
            let payload = decodeJwtResponse(response.credential);
            const prepareFormData = [
                { action: 'platform_social_auth' },
                { auth_provider: 'google' },
                { token: response.credential },

                { first_name: payload.given_name },
                { last_name: payload.family_name },
                { user_login: payload.name.replace(' ', '_') },
                { email: payload.email },
                { auth_user_id: payload.sub },
                { auth_id_token: payload.aud },
                { profile_url: payload.picture }
            ];

            const formData = platformFormData(prepareFormData);

            try {
                toast.success('Please wait...');
                const jsonRes = await ajaxHandler(formData);

                const { success, data } = jsonRes;
                if (success) {
                    toast.success('Authentication success');
                    window.location.href = data;
                } else {
                    toast.error(data);
                }
            } catch (error) {
                toast.error('Authentication failed');
            }
        }
    }

})